import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../lib/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast, Toaster } from 'sonner';
import { Lock, Loader2 } from 'lucide-react';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await auth.login(password);
      toast.success('Logged in!');
      navigate('/admin');
    } catch {
      toast.error('Wrong password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-neutral-50 to-orange-50/40 px-4">
      <Toaster position="top-center" richColors />
      <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg border border-neutral-200 p-8 w-full max-w-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-lg bg-orange-500 text-white grid place-items-center">
            <Lock className="w-5 h-5" />
          </div>
          <div>
            <div className="font-bold text-lg">Admin Panel</div>
            <div className="text-[12px] text-neutral-500">Login to edit your website</div>
          </div>
        </div>
        <label className="text-[12px] font-medium text-neutral-700">Admin Password</label>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter admin password"
          className="mt-1"
          autoFocus
        />
        <Button type="submit" disabled={loading} className="w-full mt-4 bg-orange-500 hover:bg-orange-600">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Login'}
        </Button>
        <p className="text-[11px] text-neutral-500 mt-4 text-center">Default password is <code className="bg-neutral-100 px-1 rounded">admin123</code> — change in backend .env</p>
      </form>
    </div>
  );
};

export default AdminLogin;
